<div *ngFor="let timeSlot of groupedTimeSlots" class="col-12 col-sm-6 col-lg-4 col-xl-3">
  <a (click)="onClickTimeSlot(timeSlot)">
    <div class="event-box">
      <div class="event-box-inner">
        <span>{{ getHourString(timeSlot.fromTime) }}</span>:<span class="minutes">{{ getMinutesString(timeSlot.fromTime) }}</span> -
        <span>{{ getHourString(timeSlot.toTime) }}</span>:<span class="minutes">{{ getMinutesString(timeSlot.toTime) }}</span>
      </div>
    </div>
  </a>
</div>
